import React from "react";

interface StepperProps {
  steps: string[];
  completedSteps: number[];
  currentStep: number;
}

const Stepper: React.FC<StepperProps> = ({ steps, completedSteps, currentStep }) => {
  return (
    <ol className="flex flex-wrap justify-between items-center w-full text-sm font-medium text-center text-gray-500 dark:text-gray-400 sm:text-base">
      {steps.map((step, index) => {
        const isCompleted = completedSteps.includes(index);
        const isCurrent = currentStep === index; 
        const isLastStep = index === steps.length - 1;

        return (
          <li
            key={index}
            className={`relative flex items-center mt-2 sm:mb-0 ${
              !isLastStep
                ? "flex-grow after:content-[''] after:w-0 after:h-1 after:bg-gray-200 after:hidden sm:after:inline-block after:mx-3 xl:after:mx-3 dark:after:bg-gray-700"
                : ""
            } ${isCompleted ? "text-blue-600 dark:text-blue-500" : ""}`}
          >
            <div
              className={`relative flex items-center whitespace-nowrap ${
                isCurrent ? "text-black dark:text-white" : ""
              }`}
              style={{ lineHeight: "1.8" }} // Added line height for better spacing
            >
              {isCompleted ? (
                <svg
                  className="w-3.5 h-3.5 sm:w-4 sm:h-4 me-2.5"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                </svg>
              ) : (
                <span className="me-2">{index + 1}</span>
              )}
              {step}
              {isCurrent && (
                <span className="absolute bottom-[-4px] left-0 w-full h-1 bg-gradient-to-r from-blue-300 to-cyan-700 rounded-full animate-pulse"></span>
              )}
            </div>
          </li>
        );
      })}
    </ol>
  );
};

export default Stepper;